import { DreamSearchProgramItem } from "./DreamSearchProgramItem";
import { DreamSearchViewerResult } from "@portal/app/_common/types/dreamSearch";
import { MixpanelEventName } from "@portal/app/_common/types/mixpanel";
import { DreamSearchStudentTestimonialItem } from "./DreamSearchStudentTestimonialItem";
import { isTestimonial, Testimonial } from "../../utils/resultsHelpers";

export const DreamSearchProgramItems = ({
  items,
  eventName,
  programHeadingComponent,
}: {
  items: (DreamSearchViewerResult | Testimonial)[];
  eventName: MixpanelEventName;
  programHeadingComponent?: "h3" | "span";
}) => {
  return items.map((item, idx) =>
    isTestimonial(item) ? (
      <DreamSearchStudentTestimonialItem key={item.text} {...item} />
    ) : (
      <DreamSearchProgramItem
        key={item.id}
        i={idx}
        item={item}
        eventName={eventName}
        programHeadingComponent={programHeadingComponent}
      />
    )
  );
};
